export default {
  ziweiMaj: 'emperor',
  tianjiMaj: 'advisor',
  taiyangMaj: 'sun',
  wuquMaj: 'general',
  tiantongMaj: 'fortunate',
  lianzhenMaj: 'judge',
  tianfuMaj: 'empress',
  taiyinMaj: 'moon',
  tanlangMaj: 'wolf',
  jumenMaj: 'advocator',
  tianxiangMaj: 'minister',
  tianliangMaj: 'sage',
  qishaMaj: 'marshal',
  pojunMaj: 'rebel',
  zuofuMin: 'officer',
  youbiMin: 'helper',
  wenchangMin: 'scholar',
  wenquMin: 'artist',
  lucunMin: 'money',
  tianmaMin: 'horse',
  qingyangMin: 'driven',
  tuoluoMin: 'tangled',
  huoxingMin: 'impulsive',
  lingxingMin: 'spark',
  tiankuiMin: 'assistant',
  tianyueMin: 'aide',
  dikongMin: 'ideologue',
  dijieMin: 'fickle',
  tiankong: 'utopian',
  tianxing: 'serious',
  tianyao: 'social',
  jieshen: 'considery',
  yinsha: 'gloomy',
  tianxi: 'cheerful',
  tianguan: 'solemn',
  tianfu: 'lucky',
  tianku: 'upset',
  tianxu: 'frail',
  longchi: 'talented',
  fengge: 'refined',
  hongluan: 'attractive',
  guchen: 'alone',
  guasu: 'lonely',
  feilian: 'instigated',
  posui: 'broken',
  taifu: 'honorable',
  fenggao: 'awarded',
  tianwu: 'psychic',
  tianyue: 'sickly',
  santai: 'senior',
  bazuo: 'dignified',
  engguang: 'grateful',
  tiangui: 'noble',
  tiancai: 'gifted',
  tianshou: 'ageless',
  jiekong: 'interrupted',
  xunzhong: 'meditative',
  xunkong: 'fancied',
  kongwang: 'bottomless',
  jielu: 'intercepted',
  yuede: 'peaceful',
  tianshang: 'wounded',
  tianshi: 'heaven',
  tianchu: 'gourmet',
  changsheng: 'born',
  muyu: 'infancy',
  guandai: 'adolescence',
  linguan: 'adulthood',
  diwang: 'prime',
  shuai: 'weak',
  bing: 'sick',
  si: 'dead',
  mu: 'buried',
  jue: 'dissipated',
  tai: 'embryo',
  yang: 'molding',
  boshi: 'doctor',
  lishi: 'sumo',
  qinglong: 'dragon',
  xiaohao: 'consumer',
  jiangjun: 'general',
  zhoushu: 'book',
  faylian: 'gossip',
  xishen: 'happiness',
  bingfu: 'illness',
  dahao: 'wastrel',
  fubing: 'ambush',
  guanfu: 'government',
  suijian: 'initial',
  huiqi: 'unlucky',
  sangmen: 'downcast',
  guansuo: 'tied',
  gwanfu: 'official',
  longde: 'virtuous',
  baihu: 'sinister',
  tiande: 'blessed',
  diaoke: 'sorrowing',
  jiangxing: 'capable',
  panan: 'admired',
  suiyi: 'varied',
  xiishen: 'listless',
  huagai: 'religious',
  jiesha: 'robbed',
  zhaisha: 'disastery',
  tiansha: 'condemned',
  zhibei: 'insidious',
  xianchi: 'passionate',
  yuesha: 'hapless',
  wangshen: 'perished',
  yunkui: 'assistant(D)',
  yunyue: 'aide(D)',
  yunchang: 'scholar(D)',
  yunqu: 'artist(D)',
  yunluan: 'attractive(D)',
  yunxi: 'cheerful(D)',
  yunlu: 'money(D)',
  yunyang: 'driven(D)',
  yuntuo: 'tangled(D)',
  yunma: 'horse(D)',
  liukui: 'assistant(Y)',
  liuyue: 'aide(Y)',
  liuchang: 'scholar(Y)',
  liuqu: 'artist(Y)',
  liuluan: 'attractive(Y)',
  liuxi: 'cheerful(Y)',
  liulu: 'money(Y)',
  liuyang: 'driven(Y)',
  liutuo: 'tangled(Y)',
  liuma: 'horse(Y)',
  nianjie: 'considery(Y)',
} as const;
